import React from "react";
import { Card, CardBody, Progress } from "reactstrap";
import NotificationSystem from "react-notification-system";

import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";

import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import ComponentPageError from "../utils/component-page.error";

//Icons
import { appHelpers, store } from "../../_helpers";
import DashboardTimeline from "./timeline";
import DashboardFilterPanel from "./filter-panel";
import PageEmptyContent from "../utils/page.empty-content";
import { commonService } from "../../_services";
import moment from "moment/moment";
import ReportIcon from "react-icons/lib/md/airplanemode-active";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class DashboardViewContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      TotalCount: 0,
      airlines: [],
      modal: false,
      modalClass: "",
      //Filter form
      startDate: new Date(),
      endDate: new Date(),
      filterModes: [
        {
          id: 1,
          name: "Date Type"
        },
        {
          id: 2,
          name: "Pull Modes"
        },
        {
          id: 3,
          name: "Status"
        },
        {
          id: 4,
          name: "Airline"
        }
      ],
      currentFilterParameter: {},
      selectedFilterMode: 1,
      filterOptions: [],
      filterValues: [{ Id: "DT2", Name: "Created Date", type: 1 }],
      filterValueKey: "",
      filterLabelKey: "",

      //page error
      contentError: false, //Errors that affect content on the page
      componentErrorMessages: [], //Errors generated within the component form
      componentError: false, //Errors generated within the component
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux

      //Filter options
      dateTypeFilterTypeOptions: [
        { Id: "DT1", Name: "Process Date", type: 1 },
        { Id: "DT2", Name: "Created Date", type: 1 }
      ],
      pullModeFilterTypeOptions: [
        { Id: "PM0", Name: "FTP", type: 2, value: "0" },
        { Id: "PM1", Name: "SFTP", type: 2, value: 1 },
        { Id: "PM2", Name: "Medview", type: 2, value: 2 },
        { Id: "PM3", Name: "Email", type: 2, value: 3 },
        { Id: "PM4", Name: "Webservice", type: 2, value: 4 },
        { Id: "PM5", Name: "Data entry", type: 2, value: 5 },
        { Id: "PM6", Name: "Overland Service", type: 2, value: 6 },
        { Id: "PM7", Name: "Air France Klm FTP", type: 2, value: 7 },
        { Id: "PM8", Name: "Azman Web Service", type: 2, value: 8 },
        { Id: "PM9", Name: "Air Peace Web Service", type: 2, value: 9 },
        { Id: "PM10", Name: "Arik Web Service", type: 2, value: 10 },
        { Id: "PM11", Name: "Emirates FTP", type: 2, value: 11 }
      ],
      statusFilterTypeOptions: [
        { Id: "SF1", Name: "Pending", type: 3 },
        { Id: "SF2", Name: "Completed", type: 3 },
        { id: "SF3", Name: "Processing", type: 3 }
      ],
      //    Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },

      fetchingMore: false,
      stopFetching: false,
      //pagination params
      pageSize: 10,
      currentPage: 1
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { airlinesCarriers } = reduxState;
    if (airlinesCarriers) {
      this.setState({
        airlines: airlinesCarriers.Results,
        filterOptions: airlinesCarriers.Results
      });
    } else {
      this.fetchAirlines();
    }

    this.setState({
      reports: [],
      filterOptions: this.state.dateTypeFilterTypeOptions,
      filterLabelKey: "Id",
      filterValueKey: "Name"
    });
    this.search();

    // Add scroll event
    window.addEventListener("scroll", this.onScroll, false);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll, false);
    this.props.dispatch(alertActions.clear());
    this.props.dispatch(apiActions.endRequest());
  }

  componentWillReceiveProps = function(nextProps) {
    const { alert } = nextProps;
    const { modal } = nextProps;

    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass
        });
        this.resetForm();
      }
    }
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    if (this.state.airlineName === "") {
      _errs_["airlineName"] = "Please enter airline name";
      formValid = false;
    }
    if (this.state.shortName === "") {
      _errs_["shortName"] = "Please enter short name";
      formValid = false;
    }
    if (this.state.airlineCode === "") {
      _errs_["airlineCode"] = "Please enter airline name";
      formValid = false;
    }
    if (this.state.aviationCode === "") {
      _errs_["aviationCode"] = "Please enter aviation name";
      formValid = false;
    }
    if (this.state.airlineCode === "") {
      _errs_["airlineCode"] = "Please enter airline code";
      formValid = false;
    }
    if (this.state.ticketFormat === "") {
      _errs_["ticketFormat"] = "Please enter ticket format";
      formValid = false;
    }
    if (this.state.sisId === "") {
      _errs_["sisId"] = "Please enter SSID";
      formValid = false;
    }
    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  onRemove = notification => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      airlineId: false,
      airlineName: "",
      shortName: "",
      aviationCode: "",
      airlineCode: "",
      ticketFormat: "",
      sisId: "",
      IsLocal: false,
      carrier: false
    });
    this.resetError();
  }

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    this.resetError();
    if (this.validateInput()) {
      this.processSubmit();
    }
  };

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }
  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetForm();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };

  toggleCheckbox = attribute => {
    let currState = this.state;
    currState[attribute] = !currState[attribute];
    this.setState(currState);
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  fetchAirlines = () => {
    this.setState({ contentError: false });
    const { dispatch } = this.props;
    dispatch(commonActions.getAirlinesCarriers())
      .then(() => {
        let { airlinesCarriers } = this.props;
        this.setState({ airlines: airlinesCarriers.Results });
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
      });
  };

  search = () => {
    this.resetError();

    let { filterValues, startDate, endDate, pageSize } = this.state;

    let processStatus,
      dateType,
      source,
      airlineCode = false;
    filterValues.map(item => {
      if (item.type === 1) {
        //Date Type selected
        if (item.Id === "DT1") {
          dateType = 104;
        } else if (item.Id === "DT2") {
          dateType = 101;
        }
      } else if (item.type === 2) {
        //    PullMode selected
        source = item.value;
      } else if (item.type === 3) {
        //    status
        if (item.Name === "Pending") {
          processStatus = 100;
        } else if (item.Name === "Completed") {
          processStatus = 102;
        } else if (item.Name === "Processing") {
          processStatus = 101;
        } else {
          processStatus = 100;
        }
      } else if (item.type === undefined) {
        //    Airline selected
        airlineCode = item.Code;
      }
      return true;
    });
    let parameter = {
      StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
      EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59"
    };
    if (source) {
      parameter.Source = source;
    }
    if (dateType) {
      parameter.Datetype = dateType;
    }
    if (processStatus) {
      parameter.ProcessStatus = processStatus;
    }
    if (airlineCode) {
      parameter.AirlineCode = airlineCode;
    }
    const { dispatch } = this.props;
    dispatch(apiActions.startRequest());
    let payload = {
      PageSize: pageSize,
      From: 0,
      Parameter: parameter
    };

    commonService.getDashboardReport(payload).then(
      res => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          const dashboard = res.response;
          this.setState({
            currentPage: 1,
            stopFetching: false,
            TotalCount: dashboard.TotalCount,
            reports: dashboard.Results,
            currentFilterParameter: parameter
          });
          dispatch(apiActions.endRequest());
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          dispatch(apiActions.endRequest());
        }
      },
      error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
      }
    );
  };

  fetchMore = () => {
    const {
      pageSize,
      currentPage,
      requesting,
      stopFetching,
      fetchingMore
    } = this.state;
    if (!stopFetching && !requesting && !fetchingMore) {
      this.setState({ fetchingMore: true }); //prevent
      let fromIndex = pageSize * currentPage;
      const { dispatch } = this.props;
      dispatch(apiActions.startRequest());
      const payload = {
        PageSize: pageSize,
        From: fromIndex,
        Parameter: this.state.currentFilterParameter
      };
      commonService
        .getDashboardReport(payload)
        .then(res => {
          if (res.status === appConstants.SUCCESS_RESPONSE) {
            const dashboard = res.response;
            const currReports = this.state.reports;
            currReports.push(...dashboard.Results);
            // console.log('New Rec', dashboard.Results);
            const fetchStatus = dashboard.Results.length > 0;
            this.setState({
              fetchingMore: false,
              stopFetching: !fetchStatus,
              TotalCount: dashboard.TotalCount,
              reports: currReports,
              currentPage: currentPage + 1
            });
            dispatch(apiActions.endRequest());
          } else if (res.status === appConstants.ERROR_RESPONSE) {
            dispatch(alertActions.error(res.response));
            dispatch(apiActions.endRequest());
            this.setState({ fetchingMore: false });
          }
        })
        .catch(err => {
          let errorMessage = appHelpers.interpretErrorResponse(err);
          dispatch(alertActions.error(errorMessage));
          dispatch(apiActions.endRequest());
          this.setState({ fetchingMore: false });
        });
    }
  };

  handleFilterModeChange = target => {
    let currMode = target.id;
    this.setState({ selectedFilterMode: currMode });
    switch (currMode) {
      case 1:
        return this.setState({
          filterOptions: this.state.dateTypeFilterTypeOptions,
          filterLabelKey: "Id",
          filterValueKey: "Name"
        });
      case 2:
        return this.setState({
          filterOptions: this.state.pullModeFilterTypeOptions,
          filterLabelKey: "Id",
          filterValueKey: "Name"
        });
      case 3:
        return this.setState({
          filterOptions: this.state.statusFilterTypeOptions,
          filterLabelKey: "Id",
          filterValueKey: "Name"
        });
      case 4:
        return this.setState({
          filterOptions: this.state.airlines,
          filterLabelKey: "Id",
          filterValueKey: "Name"
        });
      default:
        return this.setState({
          filterOptions: this.state.dateTypeFilterTypeOptions,
          filterLabelKey: "Id",
          filterValueKey: "Name"
        });
    }
  };

  handleSelectedFilterValuesChange = target => {
    let currFilterValues = this.state.filterValues;
    let newValue = target.filter(x => !currFilterValues.includes(x));
    let removedValue = currFilterValues.filter(x => !target.includes(x));
    // console.log({target, newValue, removedValue})

    if (removedValue.length === 0) {
      let found = false;
      currFilterValues.forEach(function(item, key) {
        if (item.type === newValue[0].type) {
          currFilterValues[key] = newValue[0];
          found = true;
        }
      });
      if (!found) {
        currFilterValues = target;
      }
      this.setState({ filterValues: currFilterValues });
    } else {
      this.setState({ filterValues: target });
    }
  };

  onScroll = () => {
    let { currentFilterParameter, stopFetching, TotalCount } = this.state;
  
    if (Object.keys(currentFilterParameter).length > 0 && TotalCount > 0) {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 100
      ) {
        if (!stopFetching) {
          this.fetchMore();
        }
      }
    }
  };



  render() {
    const { requesting } = this.props;
    const { pageRequesting } = this.props;
    const {
      contentError,
      error,
      TotalCount,
      reports,
      fetchingMore,
      stopFetching,
      filterModes,
      selectedFilterMode,
      filterOptions,
      filterValueKey,
      filterLabelKey,
      filterValues
    } = this.state;
    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody>
                {/*Form to Filter Dashboard*/}
                <div>
                  <DashboardFilterPanel
                    filters={filterModes}
                    selectedFilterMode={selectedFilterMode}
                    filterOptions={filterOptions}
                    filterValues={filterValues}
                    filterLabelKey={filterLabelKey}
                    filterValueKey={filterValueKey}
                    onFilterModeValueChange={this.handleFilterModeChange}
                    onSelectedFilterValuesChange={
                      this.handleSelectedFilterValuesChange
                    }
                    startDateChange={startDate => this.setState({ startDate })}
                    endDateChange={endDate => this.setState({ endDate })}
                    onSearch={this.search}
                  />
                </div>
                {!pageRequesting && error && (
                  <ComponentPageError error={error} />
                )}

                {!pageRequesting && !error && TotalCount > 1 && (
                  <h5 className="font-weight-normal mb-1">
                    <ReportIcon size="22" color="#43a8df" />
                    {appHelpers.numberWithCommasOnly(TotalCount)} records found
                  </h5>
                  // <h6 className="col-sm-12 response-counter">{ TotalCount } records found</h6>
                )}
                {!pageRequesting && !error && TotalCount === 1 && (
                  <h6 className="col-sm-12 response-counter">
                    {TotalCount} record found
                  </h6>
                )}
                {!pageRequesting && !error && (
                  <DashboardTimeline reports={reports} />
                )}
                {!error && fetchingMore && (
                  <h5 className="text-center mt-3">Loading more...</h5>
                )}
                {!error && stopFetching && reports.length !== 0 && (
                  <h5 className="text-center mt-3">End of records</h5>
                )}
                {!error &&
                  reports !== false &&
                  (!pageRequesting && reports.length === 0) && (
                    <PageEmptyContent message="No record match your search!" />
                  )}
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { modal, alert, airlinesCarriers } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    modal,
    alert,
    airlinesCarriers
  };
}
export default connect(mapStateToProps)(DashboardViewContent);



// WEBPACK FOOTER //
// ./src/views/dashboard/view-content.js